import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { addResource } from '../../features/resources/resourceSlice';
import { useFormValidation } from '../../hooks/useFormValidation';
import Card from '../ui/Card';
import Button from '../ui/Button';
import ResourceFormFields from './form/ResourceFormFields';

interface Props {
  onSuccess: () => void;
}

const AddResourceForm: React.FC<Props> = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { values, errors, handleChange, handleSubmit, isValid } = useFormValidation(
    {
      name: '',
      quantity: '',
      unit: '',
      category: '',
      minimum_quantity: '',
      location: '',
      expiry_date: '',
      notes: '',
    },
    {
      name: (value) => (!value ? t('resources.validation.nameRequired') : ''),
      category: (value) => (!value ? t('resources.validation.categoryRequired') : ''),
      quantity: (value) => {
        if (!value) return t('resources.validation.quantityRequired');
        if (Number(value) < 0) return t('resources.validation.quantityPositive');
        return '';
      },
      unit: (value) => (!value ? t('resources.validation.unitRequired') : ''),
      minimum_quantity: (value) => {
        if (value && Number(value) < 0) return t('common.min') + ' ' + t('common.quantity') + ' ' + t('resources.validation.quantityPositive');
        return '';
      },
    },
    async (values) => {
      await dispatch(addResource({
        ...values,
        quantity: Number(values.quantity),
        minimum_quantity: values.minimum_quantity ? Number(values.minimum_quantity) : undefined,
      }));
      onSuccess();
    }
  );

  return (
    <Card>
      <form onSubmit={handleSubmit} className="space-y-6">
        <ResourceFormFields
          values={values}
          errors={errors}
          onChange={handleChange}
        />

        <div className="flex justify-end space-x-3">
          <Button
            type="button"
            variant="secondary"
            onClick={onSuccess}
          >
            {t('common.cancel')}
          </Button>
          <Button
            type="submit"
            disabled={!isValid}
          >
            {t('resources.addResource')}
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default AddResourceForm;